var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSzambelanCzasTrwania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M74.667 5.333H53.333C50.4 5.333 48 7.733 48 10.667 48 13.6 50.4 16 53.333 16h21.334C77.6 16 80 13.6 80 10.667c0-2.934-2.4-5.334-5.333-5.334zM64 74.667c2.933 0 5.333-2.4 5.333-5.334V48c0-2.933-2.4-5.333-5.333-5.333-2.933 0-5.333 2.4-5.333 5.333v21.333c0 2.934 2.4 5.334 5.333 5.334zm37.493-35.254l4-4c2.027-2.026 2.08-5.386 0-7.466l-.053-.054c-2.08-2.08-5.387-2.026-7.467 0l-4 4C85.707 25.28 75.307 21.333 64 21.333c-25.6 0-47.36 21.12-48 46.72-.693 27.094 21.013 49.28 48 49.28 26.56 0 48-21.493 48-48 0-11.306-3.947-21.706-10.507-29.92zM64 106.667c-20.64 0-37.333-16.694-37.333-37.334C26.667 48.693 43.36 32 64 32c20.64 0 37.333 16.693 37.333 37.333 0 20.64-16.693 37.334-37.333 37.334z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 116,
    r: 116,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#979797",
    strokeWidth: 8,
    d: "M0 116c0 64.065 51.935 116 116 116s116-51.935 116-116S180.065 0 116 0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.384,
    transform: "translate(52 52)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.38,
    fillRule: "nonzero",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h128v128H0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSzambelanCzasTrwania);
export default __webpack_public_path__ + "static/media/szambelan_czas_trwania.6824fc14624bbba816e536e2369eed38.svg";
export { ForwardRef as ReactComponent };